var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoldOutbound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outbound",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6228",
    "data-name": "Rectangle 6228",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 10,
    height: 10,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons8-up-right_1_",
    "data-name": "icons8-up-right(1)",
    transform: "translate(-17.504 -6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19114",
    "data-name": "Path 19114",
    d: "M29.834,13.584a.75.75,0,0,1-.75-.75V9.25H25.5a.75.75,0,1,1,0-1.5h4.334a.75.75,0,0,1,.75.75v4.334A.75.75,0,0,1,29.834,13.584Z",
    transform: "translate(-3.33)",
    fill: "#ecad00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_853",
    "data-name": "Line 853",
    d: "M0,5.75a.748.748,0,0,1-.53-.22.75.75,0,0,1,0-1.061l5-5a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061l-5,5A.748.748,0,0,1,0,5.75Z",
    transform: "translate(21.502 8.5)",
    fill: "#ecad00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldOutbound);
export default __webpack_public_path__ + "static/media/hold_outbound.b424f4be41b142cd528e6f2149942a6f.svg";
export { ForwardRef as ReactComponent };